export default "__VITE_ASSET__Bnvyk5KZ__"